export default Object.freeze({
  TIME_ALERT_MESSAGE_POPUP_ERROR: 5000,
  TIME_ALERT_MESSAGE_POPUP_OK: 3000,

  //DICTIONARY
  VALUE: "value",

  CODE: "code",
  TOKEN: "token",
  EXPIRATION: "expiration",
  USERNAME: "username",
  NAME: "name",
  ID: "id",
  SUBACCOUNT: "subaccount",
  MASTER_ACCOUNT: "master_account",
  PERMISSIONS: "permissions",
  SUBACCOUNTS: "sub_accounts",
  COST_CENTERS: "cost_centers",
  USER_TIMEZONE: "timezone",
  USER_LOGGED: "user_logged",
  SECTION: "section",
  ACTIVE_SUBACCOUNT: "active_subaccount",
  PROCESSES: "processes",
  SUPPORT: "support",
  LANGUAGE: "language",
  LAST_LOGIN_SUCCESS: "lastTimestampLogin",
  LAST_LOGIN_ERROR: "lastTimestampLoginError",


  DATE_TIME_FORMAT_A: "DD/MM/YY HH:mm",
  DATE_TIME_FORMAT_B: "DD/MM/YY",
  DATE_TIME_FORMAT_C: "HH:mm:ss",
  DATE_TIME_FORMAT_D: "dddd DD/MM/YY HH:mm",
  DATE_TIME_FORMAT_E: "dddd DD/MM/YY",
  PROCESS_NAME: "process_name",
  PROCESS_DESCRIPTION: "process_description",
  PROCESS_CODE: "process_code",
  PROCESS_IMAGE: "process_image",
  PROCESS_STEPS: "process_steps",
  PROCESS_FIELDS: "process_fields",
  PROCESS_METADATA: "process_metadata",
  PROCESS_VALUE: "value",
  PROCESS_RECIPIENTS: "process_recipients",

  PROPERTY: "property",
  PROPERTY_NAME: "property_name",
  PROPERTY_VALUE: "property_value",
  FIELD_KEY: "field_key",
  FIELD_VALUE: "value",
  FIELD_VALID: "valid",
  FIELD_TYPE: "type",
  LINKED_GROUPS: "linked_groups",

  FIELD_SEPARATOR: "%%",
  FIELD_SEPARATOR_B: "#@#",
  FIELD_COUNTRY_CODE: "country_code",
  FIELD_MOBILE_PHONE: "mobile_phone",
  FIELD_EMAIL: "email_address",
  FIELD_NAME: "name",
  FIELD_SURNAME: "surname",
  FIELD_LANGUAGES: "__languages",
  FIELD_LANGUAGE: "language",
  FIELD_CONTACT_ID: 'id',

  CONTACT_ID: "contact_id",
  CONTACT_NAME: "contact_name",
  CONTACT_SURNAME: "contact_surname",
  CONTACT_EMAIL: "contact_email",
  CONTACT_PHONE: "contact_phone",
  CONTACT_COUNTRY_CODE: "contact_country_code",

  SUB_ACCOUNT_NAME: "sub_account_name",
  SUB_ACCOUNT_CODE: "sub_account_code",

  EVENTS: "events",
  TYPE: "type",

  GROUP: "group",
  CURRENT_GROUP: "current_group",
  GROUP_INFO: "group_info",
  GROUP_PERMISSIONS: "group_permissions",
  GROUP_SUBACCOUNTS: "group_subaccounts",
  GROUP_PROCESSES: "group_processes",
  GROUP_USERS: "users",

  GROUP_ID: "group_id",
  GROUP_NAME: "group_name",
  GROUP_DESCRIPTION: "group_description",

  GROUP_LOGIN_RETRIES_QUANTITY: "login_retries_quantity",
  GROUP_LOGIN_RETRIES_TIME: "login_retries_time",
  GROUP_MINDAYS_PASSWORD_CHANGE: "mindays_password_change",
  GROUP_PASSWORD_EXPIRATION: "password_expiration",
  GROUP_PASSWORDS_QUANTITY: "passwords_quantity",
  GROUP_MASTER_ACCOUNT_ADMIN: "master_account_admin",
  GROUP_MASTER_ACCOUNT_CODE: "master_account_code",
  GROUP_SESSION_EXPIRATION: "session_expiration",
  GROUP_CONTACT_EMAIL: "group_contact_email",

  TRANSACTION_PENDING: "transaction_pending",
  TRANSACTION_PROCESSING: "transaction_processing",
  TRANSACTION_OK: "transaction_ok",
  TRANSACTION_ERROR: "transaction_error",

  SERVER_BUS_EVENT_PERMISSION: "server_bus_event_permission",
  SERVER_BUS_EVENT_PERMISSION_BACK: "server_bus_event_permission_back",
  SERVER_BUS_EVENT_PERMISSION_SUBACCOUNT: "server_bus_event_permission_subaccount",
  SERVER_BUS_EVENT_FILE_UPLOADED: "server_bus_event_file_uploaded",

  NOTIFICATIONS_ALL: "ALL",
  NOTIFICATIONS_NONE: "NONE",
  NOTIFICATIONS_CUSTOM: "CUSTOM",

  NOTIFICATIONS_INTERVAL_REAL_TIME: "REAL_TIME",
  NOTIFICATIONS_INTERVAL_GROUPED: "GROUPED",

  WORKING_DAY_START_TIME: 8,
  WORKING_DAY_END_TIME: 17,
  WORKING_WEEK_DAYS: [1, 2, 3, 4, 5],

  EMAIL_REGEX: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  // PHONE_REGEX: /^((?:\\+|00)[17](?: |\\-)?|(?:\\+|00)[1-9]\\d{0,2}(?: |\\-)?|(?:\\+|00)1\\-\\d{3}(?: |\\-)?)?(0\\d|\\([0-9]{3}\\)|[1-9]{0,3})(?:((?: |\\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\\-)[0-9]{3}(?: |\\-)[0-9]{4})|([0-9]{7}))$/
  PHONE_REGEX: /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
  PHONE_REGEX_WITHOUT_PREFIX: /^[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,

  BYTES_LIMIT_10MB: 10000000,
  BYTES_LIMIT_18MB: 18000000,
  BYTES_LIMIT_12MB: 12000000,
  BYTES_LIMIT_14MB: 14000000,
  SIZE_FACTOR_BASE64_FILE: 0.3,

  EMAIL_DEFAULT_TEMPLATE: '<!DOCTYPE html><html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en"><head><title></title><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><!--[if mso]><xml><o:officedocumentsettings><o:pixelsperinch>96</o:pixelsperinch><o:allowpng></o:officedocumentsettings></xml><![endif]--><style>*{box-sizing:border-box}body{margin:0;padding:0}a[x-apple-data-detectors]{color:inherit!important;text-decoration:inherit!important}#MessageViewBody a{color:inherit;text-decoration:none}p{line-height:inherit}.desktop_hide,.desktop_hide table{mso-hide:all;display:none;max-height:0;overflow:hidden}.image_block img+div{display:none}@media (max-width:720px){.row-content{width:100%!important}.mobile_hide{display:none}.stack .column{width:100%;display:block}.mobile_hide{min-height:0;max-height:0;max-width:0;overflow:hidden;font-size:0}.desktop_hide,.desktop_hide table{display:table!important;max-height:none!important}}</style></head><body style="background-color:#fff;margin:0;padding:0;-webkit-text-size-adjust:none;text-size-adjust:none"><table class="nl-container" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff"><tbody><tr><td><table class="row row-1" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"><tbody><tr><td><table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;color:#000;width:580px" width="700"><tbody><tr><td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-top:30px;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0"><table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"><tr><td class="pad" style="width:100%;padding-right:0;padding-left:0"><div class="alignment" align="center" style="line-height:10px" class="mceNonEditable"><img src="%%logoURL%%" class="mceNonEditable" style="display:block;height:auto;border:0;width:150px;max-width:100%" width="150" alt="Logo" title="Logo"></div></td></tr></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><div style="background-color:transparent"><div style="Margin:0 auto;min-width:320px;max-width:500px;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;background-color:transparent" class="block-grid"><div style="border-collapse:collapse;display:table;width:100%;background-color:transparent"><!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="background-color:transparent" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px"><tr class="layout-full-width" style="background-color:transparent"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="500" style="width:500px;padding-right:0;padding-left:0;padding-top:15px;padding-bottom:15px;border-top:0 solid transparent;border-left:0 solid transparent;border-bottom:0 solid transparent;border-right:0 solid transparent" valign="top"><![endif]--><div class="col num12" style="min-width:320px;max-width:500px;display:table-cell;vertical-align:top"><div style="background-color:transparent;width:100%!important"><!--[if (!mso)&(!IE)]><!--><div style="border-top:0 solid transparent;border-left:0 solid transparent;border-bottom:0 solid transparent;border-right:0 solid transparent;padding-top:15px;padding-bottom:15px;padding-right:0;padding-left:0"><div class="content-block"></div><!--<![endif]--><!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--></div></div><!--[if (mso)|(IE)]><![endif]--></div></div></div></body></html>'
})
